module.exports = __webpack_public_path__ + "media/bootstrap-icons/textarea-resize-a8e9a43b.svg";